<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { useProductStore } from '~/store/product/productStore';
import { useUserStore } from '~/store/user/userStore';
import { NOTIFICATION_STATUS, useNotificationStore } from '~/store/notificationStore';
import { MODAL_PRODUCT_AVAILABILITY } from '~/store/modalStore';

const productStore = useProductStore();
const userStore = useUserStore();
const { displayNotification } = useNotificationStore()

const {
  unavailableProductSizes,
  product
} = storeToRefs(productStore);

const {
  user,
  currentGender,
} = storeToRefs(userStore);

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)

const subscribe = ref(false);
const submitted = ref(false);
const selectedEmail = ref(user.value ? user.value.email : '');
const selectedSize = ref(null);

const submit = (e: Event) => {
  e.preventDefault()

  const form = new FormData();
  if (!selectedEmail.value) {
    return;
  }

  if (!selectedSize.value) {
    return;
  }

  form.append('productId', selectedSize.value.id);
  form.append('email', selectedEmail.value);
  form.append('subscribe', subscribe.value.toString());
  form.append('gender', currentGender.value);

  productStore.subscribeToVariant(form)
    .then((res) => {
      if (!res) {
        displayNotification(res.message, NOTIFICATION_STATUS.ERROR)
        return;
      }

      submitted.value = true;
    })
    .catch((e) => {
      displayNotification(e, NOTIFICATION_STATUS.ERROR)
    });
}
</script>

<template>
  <Modal
         :id="MODAL_PRODUCT_AVAILABILITY"
         classes="modal--small"
         :is-visible="isModalVisible"
         :title="$t('www.product_availability.modal.title')"
         @close="closeModal">
    <div class="product-availablility">
      <form v-if="!submitted" data-product-availability="content">
        <div class="mb-2">
          <span v-if="user">{{ $t('www.product_availability.modal.text_w_mail', {'email': user.email}) }}</span>
          <span v-else>{{ $t('www.product_availability.modal.text_wo_mail') }}</span>
        </div>
        <div class="cinput__wrapper">
          <select v-model="selectedSize" class="cinput--select">
            <option value="" selected disabled>{{ $t('www.product_availability.select.placeholder') }}</option>
            <option
                v-for="(unavailableProductSize, index) in unavailableProductSizes"
                :key="index"
                :value="unavailableProductSize"
                :name="unavailableProductSize.id">
              {{ unavailableProductSize.size }}
            </option>
          </select>
          <span class="text-message--error text-message hidden">{{ $t('www.product_availability.select.error') }}</span>
        </div>
        <div v-if="selectedSize" class="cinput__wrapper mt-h">
          <input v-model="selectedEmail" type="email" required class="cinput--text" :placeholder="$t('www.product_availability.email.placeholder')">
          <span class="text-message--error text-message hidden">{{ $t('www.product_availability.email.error') }}</span>
        </div>
        <div class="mb-2 ccheckbox">
          <input id="sub_newsletter" v-model="subscribe" type="checkbox" >
          <label for="sub_newsletter" style="line-height: 33px;">{{ $t('www.product_availability.newsletter.subscribe') }}</label>
        </div>
        <button
                class="cbtn cbtn--dark cbtn--large"
                data-tclz-selector="availability-modal"
                :data-tclz-label="product.categoryPath"
                data-tclz-category="product"
                data-tclz-action="email alert subscription"
                @click="submit">
          {{ $t('www.product_availability.button') }}
        </button>
      </form>
      <div v-else>
        <div class="mb-2" v-html="$t('www.product_availability.modal.text_finished', {'email': selectedEmail, 'size': selectedSize.size})"/>
        <button class="cbtn cbtn--dark cbtn--large" @click="closeModal">
          {{ $t('www.product_availability.button_finish') }}
        </button>
      </div>
    </div>
  </Modal>
</template>
